import React, { useRef } from "react";
import {
  IconWrapper,
  ModalStyles,
  OverlayStyles
} from "./kelas-live-cmb-modal.styles";
import { Portal } from "components/portal/portal";
import { useClickOutside } from "hooks/use-click-outside/use-click-outside";
import { CrossIcon } from "components/icons/cross-icon";
import { IconButton } from "styles/common/icon-button";
import { useLockBodyScroll } from "hooks/use-lock-body-scroll/use-lock-body-scroll";
import { KelasLiveCMBModalProps } from "./kelas-live-cmb-modal.types";

const KelasLiveCMBModal = ({
  children,
  isOpen,
  onClose,
  closeOnClickOutside = true
}: KelasLiveCMBModalProps): JSX.Element | null => {
  const ref = useRef(null);

  const handleClickOutside = () => {
    closeOnClickOutside && onClose();
  };

  useClickOutside(ref, handleClickOutside);
  useLockBodyScroll(isOpen);

  if (!isOpen) {
    return null;
  }
  return (
    <Portal>
      <OverlayStyles />
      <ModalStyles ref={ref}>
        <IconWrapper>
          <IconButton onClick={onClose} aria-label="close">
            <CrossIcon />
          </IconButton>
        </IconWrapper>
        {children}
      </ModalStyles>
    </Portal>
  );
};

export { KelasLiveCMBModal };
